export const styles = theme => ({
    productCard: {
        animation: "fadeIn 0.5s",
        border: "2px solid #f0f0f0 !important",
        backgroundColor: "white",
        padding: 16,
        height: 180,
        position: "relative" as const,
        "& a": {
            marginBottom: 2,
            fontSize: 16,
            fontWeight: 700,
            fontFamily: "newsGothic_regular, Arial, Verdana, Helvetica, sans-serif",
            textDecoration: "none",
        },
        "& p": {
            marginBottom: 24,
            fontSize: 14,
            height: 28,
        },
        "& ul": {
            display: "inline-flex",
            paddingLeft: 0,
            bottom: 10,
            paddingTop: 24,
            position: "absolute",
        },
        "& li": {
            fontSize: 10,
            listStyle: "none",
        },
        "&:hover": {
            border: "2px solid #009 !important",
            cursor: "pointer",
            transition: "0.5s",
            backgroundColor: "#009",
            "& p": {
                color: "white",
            },
            "& h3": {
                color: "white",
            },
            "& span": {
                color: "white",
            },
            "& img": {
                webkitFilter: "invert(100%)", /* safari 6.0 - 9.0 */
                filter: "invert(100%)"
            }
        }
    },
    productLogo: {
        width: "100%",
        textAlign: "right" as const,
        "& img": {
            height: 23,
            marginLeft: 10,
        },
        height: 28,
        marginBottom: 16,
    },
    productBuyingOption: {
        padding: "4px 16px",
        backgroundColor: "#f5f5f5",
        textTransform: "uppercase" as const,
        marginRight: 16,
    },
    price: {
        paddingTop: 6,
        fontSize: 12,
    }
});